import { useCallback } from 'react';
import { useEventSchedule } from './useEventSchedule';


export function useSpeakerProgramItems(eventId, speakerId) {
    const filter = useCallback(
        (session) => session.speakers.find((speaker) => speaker.id == speakerId),
        [eventId, speakerId]
    ), sessions = useEventSchedule(eventId, { filter });

    return sessions;
}
